import icon from 'vue-svgicon';

icon.register({
    'bold/email-action-reply': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M19.618 10.679c-3.011-2.67-7.125-2.853-8.859-2.793a.249.249 0 0 1-.259-.25V5.064A1 1 0 0 0 8.858 4.3l-7.494 6.366a1 1 0 0 0-.364.772.986.986 0 0 0 .351.76l7.513 6.637a1 1 0 0 0 1.636-.773v-3.035a.249.249 0 0 1 .2-.244c1.908-.4 8.135-1.158 11.36 4.89a.5.5 0 0 0 .94-.235c0-3.821-1.138-6.767-3.382-8.759z"/>`,
    },
});
